import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '../../../users.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-services-functions-add',
  templateUrl: './service-functions-add.component.html',
  styleUrls: ['./service-functions-add.component.scss'],
  standalone: false,
})
export class ServiceFunctionsAddModalComponent implements OnInit {
  needRequiredFieldError: boolean;
  backendError: boolean;
  addServiceFunctionLoading = false;
  addServiceFunctionForm = new UntypedFormGroup({
    service_function_name: new UntypedFormControl(),
    description: new UntypedFormControl(),
  });

  constructor(
    public activeModal: NgbActiveModal,
    private usersService: UsersService
  ) {}

  ngOnInit() {}

  onSubmitAddNewServiceFunctionForm() {
    this.backendError = null;
    this.needRequiredFieldError = false;

    if (!this.checkTypedValidRequiredFields()) {
      this.needRequiredFieldError = true;
      return;
    }

    this.addServiceFunctionLoading = true;

    this.usersService
      .createServiceFunction(
        Object.assign(this.addServiceFunctionForm.value, {
          sf_id: null,
        })
      )
      .subscribe(
        (response) => {
          this.activeModal.close();
          this.addServiceFunctionLoading = false;
        },
        (error) => {
          this.backendError = true;
          this.addServiceFunctionLoading = false;
        }
      );
  }

  checkTypedValidRequiredFields() {
    return this.addServiceFunctionForm.value.service_function_name && this.addServiceFunctionForm.value.description;
  }
}
